import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20leather%20handbags%20and%20small%20accessories%20arranged%20on%20a%20soft%20beige%20linen%20surface%20warm%20natural%20window%20light%20minimalist%20fashion%20editorial%20photography%20clean%20neutral%20aesthetic%20gentle%20shadows%20high%20detail&width=1600&height=600&seq=cta-bg-02&orientation=landscape"
          alt="AllChinaBuy bags and accessories"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-900/80" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4 md:mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-sm md:text-base text-white/80 leading-relaxed mb-8 md:mb-10 max-w-xl mx-auto">
            {t('cta.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-primary-500 text-background-50 font-medium text-sm md:text-base rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('cta.button_main')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-white/15 backdrop-blur-sm text-white font-medium text-sm md:text-base rounded-md border border-white/30 hover:bg-white/25 transition-colors whitespace-nowrap"
            >
              {t('cta.button_buy')}
              <i className="ri-shopping-bag-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}